import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledSummaryHeadcount = styled.div`
  height: 15rem;
  position: relative;
  background-color: ${getColor('catskillGray')};
  & > .row {
    padding-top: 1.2rem;
    padding-left: 1.2rem;
    font-size: 1.4rem;
  }
  & > img.background-decorator {
    position: absolute;
    bottom: 0;
    right: 2rem;
    height: 60%;
  }
`;

export const StyledSummaryWizard = styled.div`
  &.isLoading {
    height: 100%;
    & .summary-loader {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 90%;
      & > .loader {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 3rem;
      }
    }
  }
  & > header {
    margin-top: 2rem;
    font-size: 1.6rem;
  }
  & > main {
    & .summary-columns {
      margin-top: 3rem;
      display: flex;
      justify-content: space-around;
      & > .col {
        width: 43%;
        & > header {
          width: 100%;
          font-size: 1.4rem;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #c4c4c4;
          padding-left: 2rem;
          padding-bottom: 0.8rem;
          & > svg {
            margin-right: 1rem;
          }
        }
        & > main.summary-content {
          margin-top: 2rem;
          & > .row {
            padding-left: 3rem;
            padding-bottom: 1.5rem;
            font-size: 1.3rem;
          }
        }
      }
    }
    & ${StyledSummaryHeadcount} {
      margin-top: 4rem;
    }
  }
`;
